import { ENOPOrganType, EResourceType } from '#shared';

import { useHubDetails } from '../../data-context';
import { GroupedDrawerData, UnifiedResourceDetails } from '../components';

import type { DeviceResource, HumanResource } from '#entities';

export const HubDrawer = ({
  hubId = null,
  isOpen,
  onClose,
}: {
  hubId: string | null;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { resources = [], location } = useHubDetails(hubId);

  const groupedData: GroupedDrawerData = {
    Device: {},
    Surgeon: {},
    Specialist: {},
  };

  resources.forEach(({ details, teamMemberType: resourceType }) => {
    details.forEach(({ organType, resources }) => {
      groupedData[resourceType][organType] ??= [];
      (
        groupedData[
          resourceType
        ] as typeof resourceType extends EResourceType.Device
          ? Record<ENOPOrganType, DeviceResource[]>
          : Record<ENOPOrganType, HumanResource[]>
      )[organType]?.push(...(resources as HumanResource[]));
    });
  });

  return (
    <UnifiedResourceDetails
      isOpen={isOpen}
      onClose={onClose}
      location={location}
      data={groupedData}
    />
  );
};
